import EmblaCarousel from "embla-carousel";

document.addEventListener("alpine:init", () => {
	window.Alpine.data("gallery", (options = {}) => ({
		emblaApi: null,
		options: options,
		slides: null,
		total: 0,
		init() {
			const emblaNode = this.$el
			const viewportNode = emblaNode.querySelector('.embla__viewport')
			const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
			const nextBtnNode = emblaNode.querySelector('.embla__button--next')
			// const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display')

			EmblaCarousel.globalOptions = { loop: true }

			this.emblaApi = EmblaCarousel(viewportNode, this.options);

			// this.slides = this.$el.querySelectorAll(".slider__slide");
			// this.total = this.slides.length;

			this.addPrevNextBtnsClickHandlers(
				this.emblaApi,
				prevBtnNode,
				nextBtnNode
			);

			// this.updateSelectedSnapDisplay(this.emblaApi, snapDisplayNode)
		},
		addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
			const togglePrevNextBtnsState = () => {
				if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled");
				else prevBtn.setAttribute("disabled", "disabled");

				if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled");
				else nextBtn.setAttribute("disabled", "disabled");
			};

			emblaApi.on("select", togglePrevNextBtnsState).on("init", togglePrevNextBtnsState).on("reInit", togglePrevNextBtnsState);

			return () => {
				prevBtn.removeAttribute("disabled");
				nextBtn.removeAttribute("disabled");
			};
		},
		addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
			const scrollPrev = () => {
				emblaApi.scrollPrev();
			};
			const scrollNext = () => {
				emblaApi.scrollNext();
			};
			prevBtn.addEventListener("click", scrollPrev, false);
			nextBtn.addEventListener("click", scrollNext, false);

			const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);

			return () => {
				removeTogglePrevNextBtnsActive();
				prevBtn.removeEventListener("click", scrollPrev, false);
				nextBtn.removeEventListener("click", scrollNext, false);
			};
		}
	}));
});
